import {isFunction} from 'lodash-es';
import {call, fork, put, takeLatest} from 'redux-saga/effects';

import {PrincipalApi, SchoolApi, TeacherApi, UserApi} from 'static/three-oh/src/modules/apis';

import * as actions from '../actions/schoolSearchActions';
import * as types from './../constants/schoolSearchActionTypes';

export function * getSchools(payload) {
  try {
    const data = yield call(SchoolApi.getByQuery, payload);

    yield put(actions.requestSchoolsSuccess(data));
  } catch (error) {
    yield put(actions.requestSchoolsFailure(error));
  }
}

export function * addUserToSchool(user, role, school, callback) {
  user[role].school_id = school.id;
  user[role].school = school;
  user[role].user_id = user.id;

  if (role == 'principal') {
    /**
     * If the user is a school admin, we need to update its principal's school, then its
     * teacher's school.
     */
    yield call(PrincipalApi.persistPrincipal, user[role]);

    yield addUserToSchool(user, 'teacher', school, callback);
  } else {
    // User is a teacher. Update its teacher's school.
    yield call(TeacherApi.persistTeacher, user[role]);

    isFunction(callback) && callback();
  }
}

export function * updateUser(user, role, school, updateUserEmail) {
  try {
    if (updateUserEmail) {
      /**
       * Update the user's email address and send a new verification email
       */
      user.send_verification_email = true;
      yield call(UserApi.persistUser, user);
    }
    /**
     * Create the school, if it doesn't exist, and update the user with the returned School object
     */
    if (!school.id) {
      const result = yield call(SchoolApi.createSchool, school);
      const {data} = result;

      yield addUserToSchool(user, role, data);
    } else {
      yield addUserToSchool(user, role, school);
    }

    yield put(actions.getSchoolSearchSuccess());
  } catch (error) {
    yield put(actions.getSchoolSearchFailure(error));
  }
}

export function * watchGetSchools() {
  yield takeLatest(types.SCHOOLS_LOAD_REQUEST, function * init(action) {
    const schoolParams = action.payload;
    yield fork(getSchools, schoolParams);
  });
}

export function * watchUpdateUserSchool() {
  yield takeLatest(types.INITIALIZE_USER_SCHOOL_UPDATE_REQUEST, function * init(action) {
    const {user, role, school, updateUserEmail} = action.payload;

    yield fork(updateUser, user, role, school, updateUserEmail);
  });
}
